import uniqWith from 'lodash.uniqwith';
import isEqual from 'lodash.isequal';

const getUniqueObjectsArray = (array: any[]): any[] => uniqWith(array, isEqual);

export default getUniqueObjectsArray;
